export const MODAL_TYPES = {
  VERIFY: 'VERIFY',
  DIRECT_MATCH: 'DIRECT_MATCH',
  GOOD_PARTIAL_MATCH: 'GOOD_PARTIAL_MATCH',
  MODERATE_MATCH: 'MODERATE_MATCH',
  POOR_MATCH: 'POOR_MATCH',
  NO_MATCH: 'NO_MATCH',
};

export const REQUIRED_FIELDS = ['name_1', 'name_2'];
